import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "normalize.css";
import { BrowserRouter as Router } from "react-router-dom";
import { RootStore, storesContext } from "@stores";
import {
  applyAuthInterceptor,
  IMPERSONATE_STORAGE_KEY,
  setClientNotAllowedHandler,
} from "@src/utils/apiAuthInterceptor";
import { installSessionExpiredHandler } from "@src/utils/sessionExpired";
import { Analytics } from "@vercel/analytics/react";
import { initAnalytics } from "@src/utils/analytics";

// Admin impersonation hand-off: a tab opened from the admin panel arrives with
// ?__impersonate=<userId>. Persist it into this tab's sessionStorage (so the
// auth interceptor attaches X-Impersonate-User-Id) and strip the param so
// reloads/bookmarks stay clean. sessionStorage is per-tab, so closing the tab
// ends impersonation; a fresh tab with no param is the admin's own account.
try {
  const params = new URLSearchParams(window.location.search);
  const impersonateId = params.get("__impersonate");
  if (impersonateId) {
    window.sessionStorage.setItem(IMPERSONATE_STORAGE_KEY, impersonateId);
    params.delete("__impersonate");
    const qs = params.toString();
    window.history.replaceState(
      {},
      "",
      window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash
    );
  }
} catch {
  /* ignore */
}

// Apply cookie-based auth interceptor to all API requests
applyAuthInterceptor();

// Initialize product analytics (PostHog). No-op when no key is configured.
initAnalytics();

const mobxStore = new RootStore();

// Now that the stores exist, let the interceptor turn a 401 from anywhere in
// the app into a sign-out + redirect (registered as a callback so the
// interceptor itself stays free of a MobX import cycle).
installSessionExpiredHandler(mobxStore.accountStore);
// A 403 CLIENT_NOT_ALLOWED inside a team account ("Driver app only" role) sends
// the user back to their own account.
setClientNotAllowedHandler(mobxStore.accountStore.handleClientNotAllowed);

ReactDOM.render(
  <React.StrictMode>
    <storesContext.Provider value={mobxStore}>
      <Router>
        <App />
        <Analytics />
      </Router>
    </storesContext.Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
